import React from "react"

import Layout from "../components/global/Layout"
import AnimatedHero from "../components/block/AnimatedHero"
import Clients from "../components/block/Clients"
import HighlightFeature from "../components/block/HighlightFeature"
import Certs from "../components/block/Certs"
import SEO from "../components/global/SEO"
import CTA from "../components/block/CTA"
import MediaFeatureSVG from "../components/block/MediaFeatureSVG"
import styled from "@emotion/styled"

import ideation from "../images/illustration/ideation-selection.svg"
import clarity from "../images/illustration/clarity-research.svg"
import build from "../images/illustration/build-test.svg"
import learn from "../images/illustration/learn-decide.svg"
import { FaqText } from "../components/block/FaqText"
import { MiniTitle } from "../components/block/MiniTitle"

const Title = styled.h3``
const Quote = styled.blockquote`
  margin: 0;
  font-weight: 300;
  font-size: 1.4rem;
`
const Quotee = styled.p`
  padding-top: 1rem;
  font-weight: 600;
`

export default function InnovationLab() {
  return (
    <div>
      <Layout>
        <SEO
          title="Human-centered product innovation"
          description="In-depth, remote testing with real users. We help digital teams like yours avoid costly mistakes and get things right."
          image={{ src: "/opengraph.png" }}
        />
        <AnimatedHero
          image="library"
          eyebrow="Welcome to the Userfy Innovation Lab."
          title="Create Products Your Users Want. Fast."
          tellMeMore={false}
          description={
            <>
              <p>
                A people-centred process for designing successful new products
                and features.
              </p>
              <ul>
                <li>User research and insight-led</li>
                <li>Faster to product/ market fit</li>
                <li>Avoid costly mistakes</li>
              </ul>
            </>
          }
        />
        <Clients />
        <HighlightFeature
          content={
            <>
              <Title>Welcome to the Userfy innovation lab</Title>
              <Quote>
                “Userfy has been helping digital teams research, test, refine
                and optimise their digital experiences for almost five years.
                Having previously held product owner positions in the corporate
                world and then co-founded, built and sold a multi-million-pound
                digital and software business, I now leverage these experiences
                to lead the Userfy Innovation Lab.”
              </Quote>
              <Quotee>Phil Randall — Userfy Owner</Quotee>
            </>
          }
        />
        <Certs
          postContent="Feel free to get in touch for a completely no-obligation discussion about how we might be able to help."
          buttonText="Get in touch"
          buttonLink="/contact/"
        />
        <MiniTitle />
        <MediaFeatureSVG src={clarity}>
          <h2>Clarity &amp; Research</h2>
          <ul>
            <li>Agree problem and business goals.</li>
            <li>Learn about users and their needs.</li>
            <li>Understand the context of use.</li>
            <li>Test user assumptions.</li>
            <li>Fill any knowledge gaps.</li>
            <li>Competitor review.</li>
          </ul>
        </MediaFeatureSVG>
        <MediaFeatureSVG
          src={ideation}
          reverse
          backgroundColorOverride={props => props.theme.shade[90]}
        >
          <h2>Ideation &amp; Selection</h2>
          <ul>
            <li>Generate lots of innovative ideas.</li>
            <li>Envision solutions.</li>
            <li>Research best practice examples.</li>
            <li>Review the ideas.</li>
            <li>Choose the best idea.</li>
            <li>Storyboard the selected idea.</li>
          </ul>
        </MediaFeatureSVG>
        <MediaFeatureSVG src={build}>
          <h2>Build &amp; Test</h2>
          <ul>
            <li>Build a clickable prototype.</li>
            <li>Focus on usability.</li>
            <li>As high fidelity as possible.</li>
            <li>Test the prototype with real users.</li>
            <li>Understand how users feel.</li>
            <li>Learn what is working well, what isn’t and why.</li>
          </ul>
        </MediaFeatureSVG>
        <MediaFeatureSVG
          src={learn}
          reverse
          backgroundColorOverride={props => props.theme.shade[90]}
        >
          <h2>Learn &amp; Decide</h2>
          <ul>
            <li>Make an informed go/ no go decision.</li>
            <li>Optimise the design.</li>
            <li>Develop new features.</li>
            <li>Decide whether to test further.</li>
            <li>Proceed to technical build.</li>
          </ul>
        </MediaFeatureSVG>
        <FaqText />
        <CTA
          backgroundColorOverride={props => props.theme.shade[90]}
          title="Have an idea in mind?"
          postContent="Feel free to get in touch for a completely no-obligation discussion about how we might be able to help."
          buttonText="Get in touch"
          buttonLink="/contact/"
        />
      </Layout>
    </div>
  )
}
